module.exports = __webpack_public_path__ + "static/media/veh.electrico.fba82f8a.png";